import { Component } from '@angular/core';
import { NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SuperTabsController} from "../../components/ionic2-super-tabs/src";
import {ReportService} from "../../services/report.service";

@Component({
  selector: 'page-report-survey',
  templateUrl: 'report-survey.html',
})
export class ReportSurveyPage {

  data: any;
  submitAttempt = false;
  reportForm: FormGroup;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public formBuilder: FormBuilder,
      public superTabsCtrl: SuperTabsController,
      public reportService: ReportService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    let has_data = (this.data.survey != null);
    this.reportForm = this.formBuilder.group({
      skipped: [(has_data ? this.data.survey.skipped : false)],
      q1: [(has_data ? this.data.survey.q1 : false)],
      q2: [(has_data ? this.data.survey.q2 : false)],
      q3: [(has_data ? this.data.survey.q3 : false)],
      q4: [(has_data ? this.data.survey.q4 : false)],
      q5: [(has_data ? this.data.survey.q5 : false)],
      q6: [(has_data ? this.data.survey.q6 : false)],
      q7: [(has_data ? this.data.survey.q7 : false)],
      q8: [(has_data ? this.data.survey.q8 : false)],
      q9: [(has_data ? this.data.survey.q9 : false)],
      custom_q1: [(has_data ? this.data.survey.custom_q1 : '')],
      custom_q2: [(has_data ? this.data.survey.custom_q2 : '')]
    });
  }

  ionViewDidEnter() {
    console.log('ReportSurveyPage: ionViewDidEnter');
    this.initForm();
  }

  ionViewDidLeave(){
    console.log('ReportSurveyPage: ionViewDidLeave');
    this.save();
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.reportForm.valid){
      this.superTabsCtrl.setColor('reportSurveyPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportSurveyPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportSurveyPage', 'tab_error', 'mainTabs');
      this.data._valid.reportSurveyPage = -1;
    }
    this.data.survey = this.reportForm.value;
  }

  confirm(){
    this.save();
    this.superTabsCtrl.slideTo('reportSubmitPage', 'mainTabs');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-survey/report-survey.ts